const t = "_wrapper_i05bv_1", r = "_left_i05bv_16", e = "_right_i05bv_28", _ = {
  wrapper: t,
  left: r,
  right: e
};
export {
  _ as default,
  r as left,
  e as right,
  t as wrapper
};
